// export const API_URL = 'http://localhost:3090'
export const API_URL = 'https://lucatti-web.herokuapp.com'

export const LOCALSTORAGE_TOKEN_NAME = "@lucatti-b2b-token";